import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  riskAssumedAlert: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.text.primary,
  },
}))

export default styles
